import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import classNames from 'clsx';
import React from 'react';

import type { Participants } from '@swf/sports/types/event';

import styles from './TennisUnavailable.scss';

interface Props {
  participants: Participants;
  isLoading?: boolean;
  isValidInPlayStatus?: boolean;
}

const ScoreSkeletons: React.FC = () => (
  <>
    <Skeleton
      className={styles.skeleton}
      key="sets"
      variant="rect"
      height="14px"
      width="14px"
      animation="pulse"
    />
    <Skeleton
      className={styles.skeleton}
      key="games"
      variant="rect"
      height="14px"
      width="14px"
      animation="pulse"
    />
    <Skeleton
      className={styles.skeleton}
      key="points"
      variant="rect"
      height="14px"
      width="14px"
      animation="pulse"
    />
  </>
);

const TennisUnavailable: React.FC<Props> = ({ participants, isLoading, isValidInPlayStatus }) => {
  const [teamA, teamB] = participants;

  return (
    <div
      data-testid="tennis-scoreboard-unavailable"
      className={classNames({ [styles.inPlay]: isValidInPlayStatus })}
    >
      <div className={styles.team}>
        <span className={classNames(styles.score, { [styles.loading]: isLoading })}>
          {isLoading ? (
            <ScoreSkeletons />
          ) : (
            <div className={styles.unavailable}>
              <span>-</span>
              <span>-</span>
              <span>-</span>
            </div>
          )}
        </span>
        <span className={styles.name}>{teamA}</span>
      </div>
      <div className={styles.team}>
        <span className={classNames(styles.score, { [styles.loading]: isLoading })}>
          {isLoading ? (
            <ScoreSkeletons />
          ) : (
            <div className={styles.unavailable}>
              <span>-</span>
              <span>-</span>
              <span>-</span>
            </div>
          )}
        </span>
        <span className={styles.name}>{teamB}</span>
      </div>
    </div>
  );
};

export default TennisUnavailable;
